import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/annuity-payout-calculator',
  component: () => import('../../routes/AnnuityPayoutCalculator.svelte'),
  card: {
    id: 'annuity-payout-calculator',
    title: 'Annuity Payout Calculator',
    description: 'Calculate how long your annuity or retirement portfolio will last with systematic withdrawals.',
    icon: 'payments',
    iconBgClass: 'bg-teal-50',
    iconTextClass: 'text-teal-600',
    href: '/annuity-payout-calculator',
    category: 'Retirement & Tax',
  },
  seo: {
    title: 'Annuity Payout Calculator – How Long Will Your Annuity Last?',
    description: 'Free annuity payout calculator. See how long your annuity or retirement savings will last with monthly withdrawals, accounting for compound interest and compounding frequency.',
  },
};

export default meta;